import { getTheme, WBBox } from '@admiin-com/ds-web';
import { ThemeProvider, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

export const UnAuthLayout = () => {
  const theme = useTheme();
  const mergedTheme = getTheme(theme);
  return (
    <ThemeProvider theme={mergedTheme}>
      <WBBox height="100%" overflowY="scroll">
        {/* <NavBar navRight={<ChangeLanguage />} /> */}
        {/* <PageContainer sx={{ height: `calc(100vh - ${NAVBAR_HEIGHT}px)` }}> */}
        <Outlet />
        {/* </PageContainer> */}
      </WBBox>
    </ThemeProvider>
  );
};
